var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
        "ok-disabled": true,
        okText: this.$store.getters.language["common.okButton"],
        fullscreen: _vm.innerFullscreen,
        cancelText: _vm.language["common.closeButton"],
        extraTitleInfo: _vm.extraTitleInfo
      },
      on: {
        ok: _vm.handleOk,
        cancel: _vm.handleCancel,
        setInnerFullscreen: _vm.setInnerFullscreen
      }
    },
    [
      _vm.initForm
        ? _c("my-todo-form", {
            ref: "realForm",
            attrs: {
              setEdit: _vm.setEdit,
              disabled: _vm.disableSubmit,
              innerFullscreen: _vm.innerFullscreen
            },
            on: { ok: _vm.submitCallback, close: _vm.close }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }